export const NOW_SHIPPING_MODAL_ID = 'now-shipping-modal'
export const NOW_SHIPPING_MODAL_CONTAINER_ID = 'now-shipping-modal-container'
